/* ==========================================================================
   Goldtop, 26 September 2026
   Colour swatches on the "Pairs well with" recommendation cards.

   Clicking a swatch swaps the card's preview image to that colour's variant
   image and re-points the card link at that variant, so clicking through
   lands on the colour the shopper just looked at.

   Delegated from the document, because the recommendations block re-renders
   itself from a section fetch after first paint - a listener bound to the
   cards at load would be lost when that happens.
   ========================================================================== */
(function () {
  if (window.__gtRecSwatch) return;
  window.__gtRecSwatch = true;

  var SWATCH = '[data-gt-rec-swatch]';

  function pick(swatch) {
    var card = swatch.closest('.grid-product');
    var row = swatch.closest('[data-gt-rec-swatches]');
    if (!card || !row) return;

    var all = row.querySelectorAll(SWATCH);
    for (var i = 0; i < all.length; i++) {
      all[i].classList.toggle('is-selected', all[i] === swatch);
      all[i].setAttribute('aria-pressed', all[i] === swatch ? 'true' : 'false');
    }

    var src = swatch.getAttribute('data-variant-image');
    var img = card.querySelector('.grid-product__image-mask img');
    if (img && src) {
      img.setAttribute('src', src);
      img.setAttribute('srcset', src);
      if (img.hasAttribute('data-src')) img.setAttribute('data-src', src);
      if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', src);
      card.classList.add('gt-rec-picked');
    }

    var url = swatch.getAttribute('data-variant-url');
    if (url) {
      var links = card.querySelectorAll('a.grid-product__link');
      for (var j = 0; j < links.length; j++) links[j].setAttribute('href', url);
    }
  }

  function swatchFrom(target) {
    if (!target || !target.closest) return null;
    return target.closest(SWATCH);
  }

  document.addEventListener('click', function (e) {
    var swatch = swatchFrom(e.target);
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    pick(swatch);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var swatch = swatchFrom(e.target);
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    pick(swatch);
  }, true);
})();
